// Toggle a set of visible option ids in/out of the current selection, leaving
// any selected ids that fall outside the visible set untouched.
export const toggleAllVisible = (
  selectedIds: string[],
  visibleIds: string[],
  allVisibleSelected: boolean
): string[] => {
  const visible = new Set(visibleIds);
  const withoutVisible = selectedIds.filter((id) => !visible.has(id));
  return allVisibleSelected ? withoutVisible : [...withoutVisible, ...visible];
};
